import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { offlineSyncService } from './services/offlineSyncService';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA support & offline caching
serviceWorkerRegistration.register();

// Initialize automatic offline inspection queue auto-sync
offlineSyncService.initAutoSync();
